import { useCallback } from 'react';
import { getConferenceParties, ConferencePartyInfo } from '../../services/cxone-sdk.service';
import { logger } from '../../utils/logger';
import { CallState } from '../../types';

export function useConferenceRefresh(
  isConference: boolean,
  setCallState: React.Dispatch<React.SetStateAction<CallState>>
) {
  return useCallback(async () => {
    if (!isConference) {
      return;
    }

    try {
      const parties = await getConferenceParties();
      if (parties.length > 0) {
        const mappedParties = parties.map((party: ConferencePartyInfo) => ({
          partyId: party.partyId,
          partyType: party.partyType,
          name: party.name,
          phoneNumber: party.phoneNumber,
          isOriginalCaller: party.isOriginalCaller,
        }));

        setCallState((prev) => ({
          ...prev,
          conferenceParties: mappedParties,
        }));
      }
    } catch (error) {
      logger.warn('[Events] Failed to refresh conference parties:', error);
    }
  }, [isConference, setCallState]);
}
